export default "__VITE_ASSET__VJGwnla1__";